export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as genderKey, initialState as genderInitialState, State as GenderState } from './reducer';

export {
  getData as genderGetData,
  getError as genderGetError,
  getLoading as genderGetLoading,
  mapData as genderMapData,
} from './selectors';
